import React from 'react';
import styled from 'styled-components';
import styledContainerQuery from 'styled-container-query';
import Link from 'next/link';

import { GqlSpecials } from 'types/graphql';

import usePaths from 'src/hooks/use-paths';
import { Progress } from './progress';

type SpecialCardProps = {
  special: GqlSpecials;
};

export const SpecialCard = ({ special }: SpecialCardProps): JSX.Element => {
  const { href } = usePaths({ specials: true, id: `offer/${String(special._id)}` });
  const { menuDisplayName } = special;

  // TODO: Replace with actual progress value from API when available
  const progress = 50;

  return (
    <Link href={href}>
      <Wrapper href={href}>
        <Progress progress={progress} />

        <Content>
          <Name>{menuDisplayName}</Name>
          <ShopOffer>Shop Offer</ShopOffer>
        </Content>
      </Wrapper>
    </Link>
  );
};

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Wrapper = styledContainerQuery.a`
  align-items: center;
  background: #ceeedb;
  border-radius: ${({ theme }) => theme.customized.radius.lg};
  display: flex;
  gap: 12px;
  padding: 16px;
  width: 100%;

  &:container(min-width: 359px) {
    ${Content} {
      align-items: center;
      flex-direction: row;
      gap: 12px;
    }
`;

const Name = styled.div`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  line-height: ${16 / 14};
  overflow: hidden;
`;

const ShopOffer = styled.div`
  color: #00624a;
  font-size: 13px;
  font-weight: 600;
  line-height: ${16 / 13};
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;
